import {
	getData,
	getSearchInput,
	responseDashboard,
	responseSearchInput
} from './transform/DashboardTransform';
import {handlerError, ApiService} from "../ApiService";
const Dashboard = {};

const exampleResponse =
	{data: {
	dashboard:{
		id: "0001200T123",
		title: 'Dashboard',
		type: 'dashboard',
		rows: [
							{
								type: "tab",
								tabs: [
									{ title: "test1",
										rows: [{
											type: "row",
											columns: [
												{
													"title": "LISTA PACIENTES 9 (2022-04-01 2022-04-14) ",
													"type": "table",
													"table_size": "small",
													"name": "Tabla PACIENTES",
													"size": 24,
													"header": [
														{

															"title": "Padre",
															"children": [{
																"dataIndex": "nuhsa",
																"title": "Hijo"
															},
																{
																	"dataIndex": "otro",
																	"title": "Hijo 2"
																}]
														},
														{
															"title": "accion",
															"dataIndex": "action",
															"action": {
																"type": "operation"
															}
														}
													],
													"rows": [
														{
															"nuhsa": "AN0537225003",
															"otro": "Guay",
															"action": [
																{
																	"name": "Diraya",
																	"type": "new-tab",
																	"help": "texto ayuda",
																	"link": "http://emdae.hvm.sas.junta-andalucia.es/ec/accesoExterno?accion=visualizar&messageWait=no&pushHistorico=no&nuhsa=AN0537225003&nhc=&codigooperador=&cnpprofesional=&fechahora=&login=morenoalberto29l&password=613ae058b37d3542a04459dc15004f11 "
																},
																{
																	"name": "OncoAnd",
																	"type": "new-tab",
																	"help": "texto ayuda",
																	"link": "http://10.232.5.113:9008/app/oncoand/154/dashboard/P_51?nuhsa=AN0537225003&"
																}
															]
														}
													]
												}
											]
										}
										]
									}
								]

							}
						]


	}}};

const searchResponse = {"results":[{"gender":"male","name":{"title":"Mr","first":"Thomas","last":"Sanchez"},"location":{"street":{"number":9287,"name":"Plum St"},"city":"Westminster","state":"Maryland","country":"United States","postcode":41867,"coordinates":{"latitude":"85.5547","longitude":"-63.9920"},"timezone":{"offset":"+4:00","description":"Abu Dhabi, Muscat, Baku, Tbilisi"}},"email":"thomas.sanchez@example.com","login":{"uuid":"ec9e9f65-19c2-4e3e-854b-2557c4e937fb","username":"crazypanda257","password":"fireman","salt":"eKWl5o5H","md5":"dd9fe890e4346c0f46cd2e896d390f05","sha1":"82cc6337c8d49568ae3b4f9a18ae33e139c84434","sha256":"178d9bdf76e39edbcda9e35cb18cb208b7adcf3819af9ba55c92b605b759af1a"},"dob":{"date":"1962-07-05T22:15:09.831Z","age":59},"registered":{"date":"2007-11-06T16:38:31.656Z","age":14},"phone":"(729)-524-9611","cell":"(742)-380-0582","id":{"name":"SSN","value":"821-80-9002"},"picture":{"large":"https://randomuser.me/api/portraits/men/49.jpg","medium":"https://randomuser.me/api/portraits/med/men/49.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/men/49.jpg"},"nat":"US"},{"gender":"female","name":{"title":"Ms","first":"Hanna","last":"Mendoza"},"location":{"street":{"number":5514,"name":"The Grove"},"city":"Ratoath","state":"Kerry","country":"Ireland","postcode":83269,"coordinates":{"latitude":"-61.0877","longitude":"-128.7427"},"timezone":{"offset":"-12:00","description":"Eniwetok, Kwajalein"}},"email":"hanna.mendoza@example.com","login":{"uuid":"b745d009-d3e4-41d0-a004-a869b08ec5d7","username":"bigleopard233","password":"laser1","salt":"DiFonKPT","md5":"a67ad1a0cf42ee082de768db0baaca07","sha1":"be09b0d41e7503a60bc29dcd1bbb818e36600deb","sha256":"a290056c3b6d5e952f9066ca2db81a5a37ffb2d7236356ec3ac246cbb5c1e4cd"},"dob":{"date":"1990-06-04T15:34:02.342Z","age":31},"registered":{"date":"2004-10-16T06:43:00.361Z","age":17},"phone":"051-486-6253","cell":"081-781-5740","id":{"name":"PPS","value":"8364984T"},"picture":{"large":"https://randomuser.me/api/portraits/women/47.jpg","medium":"https://randomuser.me/api/portraits/med/women/47.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/women/47.jpg"},"nat":"IE"},{"gender":"male","name":{"title":"Mr","first":"John","last":"Jensen"},"location":{"street":{"number":4466,"name":"Wheeler Ridge Dr"},"city":"Palmdale","state":"Delaware","country":"United States","postcode":69555,"coordinates":{"latitude":"-66.3157","longitude":"2.1546"},"timezone":{"offset":"+10:00","description":"Eastern Australia, Guam, Vladivostok"}},"email":"john.jensen@example.com","login":{"uuid":"339ab818-2d27-4a7d-aa48-5cd18b70c5a6","username":"yellowlion475","password":"classics","salt":"7CMVqjh9","md5":"1da8e7faa85c2103f87fe1f9b54d9d2a","sha1":"c4e04282611f3747944a20a62a98f5fa1ff8ddf0","sha256":"c94ab778c604fdfbfcb57cd064b81c97eb03c673b4ad4e6bb190b784b38fb83d"},"dob":{"date":"1959-03-07T19:00:09.890Z","age":62},"registered":{"date":"2018-08-16T19:31:15.812Z","age":3},"phone":"(725)-359-3321","cell":"(835)-720-7883","id":{"name":"SSN","value":"239-35-8554"},"picture":{"large":"https://randomuser.me/api/portraits/men/62.jpg","medium":"https://randomuser.me/api/portraits/med/men/62.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/men/62.jpg"},"nat":"US"},{"gender":"male","name":{"title":"Mr","first":"Lewis","last":"Taylor"},"location":{"street":{"number":9016,"name":"Fendalton Road"},"city":"Nelson","state":"Wellington","country":"New Zealand","postcode":90514,"coordinates":{"latitude":"86.2576","longitude":"135.2165"},"timezone":{"offset":"+7:00","description":"Bangkok, Hanoi, Jakarta"}},"email":"lewis.taylor@example.com","login":{"uuid":"6f387e7f-a2af-47ac-821f-3f964eab3958","username":"ticklishbear107","password":"escape","salt":"3CzvrOB6","md5":"02f2af058db60f73c7070f834230ca76","sha1":"b9ae48d17e632c03e49718b5a0ec47c2150f1f03","sha256":"14c3f2fb358a9a1c1db173d5414f439055a75df5c514383ef27b5044435517bc"},"dob":{"date":"1970-01-15T12:12:47.375Z","age":51},"registered":{"date":"2018-01-20T10:30:50.765Z","age":3},"phone":"(241)-536-7020","cell":"(099)-823-9882","id":{"name":"","value":null},"picture":{"large":"https://randomuser.me/api/portraits/men/51.jpg","medium":"https://randomuser.me/api/portraits/med/men/51.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/men/51.jpg"},"nat":"NZ"},{"gender":"female","name":{"title":"Miss","first":"Barb","last":"Fuller"},"location":{"street":{"number":9383,"name":"Church Street"},"city":"Bangor","state":"Northamptonshire","country":"United Kingdom","postcode":"CO9V 5AB","coordinates":{"latitude":"79.6394","longitude":"-36.4089"},"timezone":{"offset":"-4:00","description":"Atlantic Time (Canada), Caracas, La Paz"}},"email":"barb.fuller@example.com","login":{"uuid":"532d59b3-0cce-4545-b59e-997e1abde48e","username":"blackpeacock702","password":"mistress","salt":"giVMjijg","md5":"5007cd7dcba7f315ef50dfb2a2840c78","sha1":"7acab63676b6be5c062ca8a5a8b634e1714d1f77","sha256":"98ff5ebad79c6dc624b5110626e0c9228d303d18c24ca83a1d943c0f459eea8a"},"dob":{"date":"1996-12-23T07:49:52.171Z","age":25},"registered":{"date":"2008-06-18T19:52:56.760Z","age":13},"phone":"017683 77279","cell":"0763-058-118","id":{"name":"NINO","value":"XX 62 20 87 P"},"picture":{"large":"https://randomuser.me/api/portraits/women/1.jpg","medium":"https://randomuser.me/api/portraits/med/women/1.jpg","thumbnail":"https://randomuser.me/api/portraits/thumb/women/1.jpg"},"nat":"GB"}],"info":{"seed":"274f5ddfbbf16e2d","results":5,"page":1,"version":"1.3"}};

Dashboard.get = ({payload: data, fake}) => {
	return (fake
		? Promise.resolve(exampleResponse)
		: ApiService.post('', getData(data)))
		.then(responseDashboard)
		.catch(handlerError);
}

Dashboard.getSearchInput = (data) => {
	return ApiService.post('', getSearchInput(data))
	// return Promise.resolve(searchResponse)
		.then(responseSearchInput)
		.catch(handlerError);
}


Dashboard.getWithFilter =
	// ToDo si descomentas esta linea tiene que indicar que es data,
	//  si te fijas en la función de arriba se declara como una función en este no. Por esto petaba
	// ApiService.post('', data)
	Promise.resolve(exampleResponse)
		.then(responseDashboard)
		.catch(handlerError);

export default Dashboard